import styled from 'styled-components'
import { Typography, Button as DefaultButton } from '~components'

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Time = styled(Typography).attrs({ as: 'b' })`
  color: #12a17f;
`

export const Button = styled(DefaultButton).attrs({ color: 'subtle' })`
  user-select: text;
  width: 100%;
  margin-top: ${({ theme }) => theme.spacing.km1};

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    user-select: none;
  }
`
export const SecondaryTypography = styled(Typography).attrs({ as: 'h3' })`
  color: ${({ theme }) => theme.neutral.text.default};
  font-size: ${({ theme }) => theme.font.size.m3};
  font-weight: ${({ theme }) => theme.font.weight.semibold};
  line-height: 48px;
  padding-left: ${({ theme }) => theme.spacing.km6};
  padding-right: ${({ theme }) => theme.spacing.km6};
  text-align: center;
`
